import { UserDetails } from '@innovation-os-ng/core/models';

/**
 * Provides methods to retrieve information about tenant users.
 */
export abstract class TenantUserDetailsService {
  /**
   * Returns tenant user detail for given user uri
   *
   * * Note: tenantUri is optional here if not provided the current tenant
   * * is used
   *
   * @param userUri User uri for which details is to be fetched.
   * @param tenantUri @optional tenant uri the user related to
   */
  public abstract getUser(userUri: string, tenantUri?: string): Promise<UserDetails>;

  /**
   * Returns multiple users details for a tenant.
   *
   * * Note: tenantUri is optional here if not provided the current tenant
   * * is used
   *
   * @param uris The user uri's of the user's for which the details
   * are to be fetched.
   *  @param tenantUri @optional tenant uri which the users are related to
   */
  public abstract getUsers(uris: Array<string>, tenantUri?: string): Promise<Array<UserDetails>>;
}
